(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us"] && !Shopify.designMode) return;
  try {
    
  const readMoreLinks = document.querySelectorAll('.profile-read-more');
  
  readMoreLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Find the closest parent .bio container
      const bioContainer = this.closest('.bio');
      
      if (bioContainer) {
        const readMoreDiv = bioContainer.querySelector('.read-more');
        
        if (readMoreDiv) {
          readMoreDiv.classList.toggle('open');
          
          // Toggle link text
          if (readMoreDiv.classList.contains('open')) {
            this.textContent = 'Read less';
          } else {
            this.textContent = 'Read more';
          }
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

    const images = document.querySelectorAll('.main-article .content img');

    images.forEach(img => {
      // Ensure the image is loaded
      if (img.complete) {
        classifyImage(img);
      } else {
        img.onload = () => classifyImage(img);
      }
    });

    function classifyImage(img) {
      const width = img.naturalWidth;
      const height = img.naturalHeight;

      if (width > height) {
        img.classList.add('landscape');
      } else if (height > width) {
        img.classList.add('portrait');
      } else {
        img.classList.add('square'); // optional
      }
    }

  // find all YouTube iframes in the page content and replace with placeholder
  var iframes = Array.from(document.querySelectorAll('iframe[src*="youtube.com/embed"]'));

  iframes.forEach(function (iframe) {
    try {
      var src = iframe.getAttribute('src') || '';
      var match = src.match(/\/embed\/([A-Za-z0-9_-]{11})/);
      if (!match) return;
      var videoId = match[1];

      // create wrapper
      var wrapper = document.createElement('div');
      wrapper.className = 'youtube-wrap';
      wrapper.setAttribute('data-video-id', videoId);
      wrapper.setAttribute('role', 'button');
      wrapper.setAttribute('tabindex', '0');
      wrapper.setAttribute('aria-label', 'Play YouTube video');

      // inner div with background thumbnail
      var inner = document.createElement('div');
      inner.className = 'youtube-inner';
      // thumbnail fallbacks: maxresdefault -> sddefault -> hqdefault
      var thumbUrls = [
        'https://i.ytimg.com/vi/' + videoId + '/maxresdefault.jpg',
        'https://i.ytimg.com/vi/' + videoId + '/sddefault.jpg',
        'https://i.ytimg.com/vi/' + videoId + '/hqdefault.jpg'
      ];
      inner.style.backgroundImage = 'url("' + thumbUrls[2] + '")'; // start with hqdefault

      // preload best thumbnail (try maxres, if loads use it)
      var img = new Image();
      img.onload = function () {
        // check naturalWidth to decide if image exists (maxres sometimes 120x90 placeholder)
        if (img.naturalWidth && img.naturalWidth > 120) {
          inner.style.backgroundImage = 'url("' + thumbUrls[0] + '")';
        } else {
          // try sd
          var img2 = new Image();
          img2.onload = function () {
            if (img2.naturalWidth && img2.naturalWidth > 120) {
              inner.style.backgroundImage = 'url("' + thumbUrls[1] + '")';
            }
          };
          img2.src = thumbUrls[1];
        }
      };
      img.src = thumbUrls[0];

      // custom play button
      var btn = document.createElement('div');
      btn.className = 'youtube-play-button';
      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '-1');
      btn.setAttribute('aria-hidden', 'true');
      btn.innerHTML = '';

      inner.appendChild(btn);
      wrapper.appendChild(inner);

      // replace original iframe with wrapper
      iframe.parentNode.replaceChild(wrapper, iframe);

      // click / keyboard handler to swap in iframe
      function insertIframe() {
        // create iframe
        var player = document.createElement('iframe');
        player.className = 'youtube-iframe';
        // add autoplay=1,rel=0 to avoid showing related videos from other channels; keep allow attributes
        player.setAttribute('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0');
        player.setAttribute('title', 'YouTube video player');
        player.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        player.setAttribute('allowfullscreen', '');
        player.setAttribute('loading', 'lazy');

        // remove contents and append iframe
        wrapper.innerHTML = '';
        wrapper.appendChild(player);

        // focus the iframe for accessibility
        player.focus();
      }

      wrapper.addEventListener('click', insertIframe);

    } catch (err) {
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-slider"] && !Shopify.designMode) return;
  try {
    
/* Blog slider */
    document.querySelectorAll('.section-blog-slider .swiper').
        forEach(function(slider) {
  var section = slider.closest('.section-blog-slider');
  var prevEl  = section.querySelector('.slider-buttons .prev');
  var nextEl  = section.querySelector('.slider-buttons .next');

  var swiper = new Swiper(slider, {
      slidesPerView: 1.12,
      spaceBetween: 5,
      mousewheel: {
          forceToAxis: true,
      },
      freeMode: true,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
      breakpoints: {
        768:  { slidesPerView: 2.2, spaceBetween: 5 },
        1024: { slidesPerView: 3.2, spaceBetween: 5 },
        1280: { slidesPerView: 4.1, spaceBetween: 5 },
      }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
var mql = window.matchMedia("(hover: hover) and (pointer: fine)");
    if (mql.matches) {
        document.body.classList.add('has-hover-enabled');
    }

    var scrolled = false;
    checkScrollState();

    function checkScrollState() {
        var header = document.querySelector('header');

        if (!header) {
            return;
        }

        if (!header.classList.contains('is-fixed') && !header.classList.contains('is-absolute')) {
            return;
        }

        if (window.scrollY < 100) {
            if (scrolled) {
                document.body.classList.remove('scrolled');
                scrolled = false;
            }
        } else {
            if (!scrolled) {
                document.body.classList.add('scrolled');
                scrolled = true;
            }
        }
    }

    let lastScrollTop = 0;
    let lastRun = 0;
    const throttleDelay = 200;
    const menu = document.getElementById("main-menu");
    const announcementBar = document.getElementById("announcement-bar");
    const menuHeight = 100;

    window.addEventListener("scroll", function () {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      // Always show menu when at the top of the page
      if (currentScroll === 0) {
        menu.classList.remove("hidden");

        if (announcementBar) {
            announcementBar.classList.remove('hidden');
        }

        if (scrolled) {
            document.body.classList.remove('scrolled');
            scrolled = false;
        }

        lastScrollTop = 0;
        lastRun = Date.now();

        return;
      }

      const now = Date.now();
      if (now - lastRun < throttleDelay) return;

      checkScrollState();

      if (currentScroll > lastScrollTop && currentScroll > menuHeight) {
        // Scrolling down past menu height
        menu.classList.add("hidden");

        if (announcementBar) {
            announcementBar.classList.add('hidden');
        }

      } else {
        // Scrolling up or not past threshold
        menu.classList.remove("hidden");

        if (currentScroll < menuHeight) {
            if (announcementBar) {
                announcementBar.classList.remove('hidden');
            }
        }

        if (scrolled && window.scrollY < 100) {
            document.body.classList.remove('scrolled');
            scrolled = false;
        }
      }

      lastScrollTop = Math.max(0, currentScroll);
      lastRun = now;
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["login-register"]) return;
  try {
    
    var login = document.getElementById('login-form');
    var recover = document.getElementById('recover-form');

    function showRecover(on) {
      if (!login || !recover) return;
      if (on) {
        login.style.display = 'none';
        recover.style.display = 'block';
      } else {
        login.style.display = 'block';
        recover.style.display = 'none';
      }
    }

    // Toggle based on hash
    function syncFromHash() {
      showRecover(window.location.hash === '#recover');
    }
    window.addEventListener('hashchange', syncFromHash);
    syncFromHash();

    // Enhance links (in case theme intercepts anchors)
    var toRecover = document.querySelectorAll('a.link-recover');
    var toLogin = document.querySelectorAll('a.link-login');
    toRecover.forEach(function(a){ a.addEventListener('click', function(e){ e.preventDefault(); window.location.hash = 'recover'; }); });
    toLogin.forEach(function(a){ a.addEventListener('click', function(e){ e.preventDefault(); window.location.hash = 'login'; }); });

  const returnInput = document.getElementById('return_to');
  if (!returnInput) return;

  let path = '/'; // default fallback

  // Use document.referrer if available
  if (document.referrer) {
    const refUrl = new URL(document.referrer);
    path = refUrl.pathname + refUrl.search + refUrl.hash; // keep query & hash
  }

  returnInput.value = path;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-banner"] && !Shopify.designMode) return;
  try {
    
/* Main Banner */
    document.querySelectorAll('.section-main-banner .swiper').
        forEach(function(slider) {
            var swiper = new Swiper(slider, {
                slideClass: 'shopify-block',
                loop: true,
                pagination: {
                    el: slider.querySelector('.swiper-pagination'),
                    clickable: true
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                }
            });
        });

            function adjustHeightSlideshow() {
                if (window.innerWidth < 767.98) {
                  var visibleHeight = window.innerHeight - 54;

                  if (document.body.classList.contains('has-announcement-bar')) {
                      visibleHeight -= 30;
                  }

                  var slides = document.querySelectorAll('.section-main-banner .shopify-block');

                  slides.forEach(function(slide) {
                    slide.style.height = visibleHeight + 'px';
                  });
              }
            }

            adjustHeightSlideshow();

            var previousWidth = window.innerWidth;

            window.addEventListener('resize', function() {
                var currentWidth = window.innerWidth;

                if (currentWidth !== previousWidth) {
                    adjustHeightSlideshow();
                    previousWidth = currentWidth;
                }
            });

            /*const container = document.querySelector('.main-banner-illustration');
            if (!container) return;

            // Respect reduced motion: never load the animation, keep poster only.
            const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (prefersReduced) return;

            const anim = container.querySelector('.banner-anim');
            if (!anim) return;

            const loadAnim = () => {
              // Set real sources only once
              if (anim.dataset.src) {
                anim.src = anim.dataset.src;
                anim.removeAttribute('data-src');
              }

              // Reveal when the animated image actually finishes decoding
              const show = () => {
                container.classList.add('anim-active');
              };

              if ('decode' in anim) {
                anim.decode().then(show).catch(() => show());
              } else {
                anim.addEventListener('load', show, { once: true });
              }
            };

            loadAnim();*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
const wrappers = document.querySelectorAll('.select-popout[data-popout]');
const closeAll = () => wrappers.forEach(w => w.classList.remove('is-open'));

wrappers.forEach(pop => {
  const toggle = pop.querySelector('[data-popout-toggle]');
  const list   = pop.querySelector('[data-popout-list]');
  const opts   = pop.querySelectorAll('[data-popout-option]');
  const inputPacks  = pop.querySelector('[data-popout-input]');
  const minus  = pop.querySelector('[data-quantity-minus]');
  const plus   = pop.querySelector('[data-quantity-plus]');

  if (!toggle || !list || !inputPacks) return;

  const packMultiple = parseInt(pop.dataset.packMultiple || '0', 10) || 0;
  const isPackMode = packMultiple > 0;

  const form = pop.closest('form[action*="/cart/add"]') || pop.closest('form');
  if (!form) return;

  const clamp = (n, min=1) => Math.max(min, parseInt(n, 10) || min);

  // Label: "Qty: 2 packs" / "Qty: 1 pack"
  function setToggleLabel(packs) {
    const span = toggle.querySelector('span') || toggle;
    if (isPackMode) {
      const word = packs === 1 ? 'pack' : 'packs';
      span.textContent = `Qty: ${packs} ${word}`;
    } else {
      span.textContent = `Qty: ${packs}`;
    }
  }

  // Keep dropdown highlighting in sync (values in PACKS)
  function markCurrent(packsVal) {
    const v = parseInt(packsVal, 10);
    opts.forEach(a => {
      const li = a.closest('li');
      const aVal = parseInt(a.dataset.value, 10);
      const isPlus = a.textContent.trim().endsWith('+');
      li?.classList.toggle('select-popout__item--current', aVal === v && !isPlus);
    });
  }

  function writeUnits(packsVal) {
    const packs = clamp(packsVal, 1);
    const units = isPackMode ? packs * packMultiple : packs;
    inputPacks.value = units;          // <- this is what Shopify receives
  }

  function setDropdownMode(packsVal) {
    const packs = clamp(packsVal, 1);
    pop.classList.remove('is-custom-qty');
    setToggleLabel(packs);
    writeUnits(packs);
    markCurrent(packs);
    pop.classList.remove('is-open');
  }

  function setCustomMode(startVal) {
    const packs = Math.max(10, clamp(startVal ?? inputPacks.value ?? 10, 1));
    pop.classList.add('is-custom-qty');
    setToggleLabel(packs);
    writeUnits(packs);
    inputPacks.focus({ preventScroll: true });
    pop.classList.remove('is-open');
  }

  // Toggle dropdown
  toggle.addEventListener('click', () => {
    const isOpen = pop.classList.contains('is-open');
    closeAll();
    if (!isOpen) pop.classList.add('is-open');
  });

  // Select an option (options hold PACKS in data-value)
  opts.forEach(a => {
    a.addEventListener('click', (e) => {
      e.preventDefault();
      const val = parseInt(a.dataset.value, 10);
      const isTenPlus = a.textContent.trim().endsWith('+');
      if (isTenPlus) setCustomMode(10);
      else setDropdownMode(val);
    });
  });

  // +/- in PACKS
  minus?.addEventListener('click', () => {
    let v = clamp(inputPacks.value) - 1;
    v = clamp(v);
    if (v < 10) setDropdownMode(v); else setCustomMode(v);
  });

  plus?.addEventListener('click', () => {
    let v = clamp(inputPacks.value) + 1;
    if (v < 10) setDropdownMode(v); else setCustomMode(v);
  });

  // Manual typing (PACKS)
  inputPacks.addEventListener('change', () => {
    const v = clamp(inputPacks.value);
    if (v < 10) setDropdownMode(v); else setCustomMode(v);
  });

  // Click outside closes
  document.addEventListener('click', (e) => {
    if (!pop.contains(e.target)) pop.classList.remove('is-open');
  });

  // Init from current PACKS value
  const initialPacks = clamp(inputPacks.value, 1);
  if (initialPacks >= 10) setCustomMode(initialPacks); else setDropdownMode(initialPacks);
});



const MINI_CART_SECTION_ID = 'mini-cart';

// Helper: get the outer Shopify wrapper for this section
function getMiniCartWrapper() {
  // If you render via {% section 'mini-cart' %}, Shopify wraps it as:
  // <div id="shopify-section-mini-cart" class="shopify-section">...</div>
  return document.getElementById(`shopify-section-${MINI_CART_SECTION_ID}`);
}

// Helper: get the inner drawer/root you toggle open
function getMiniCartRoot() {
  return document.querySelector('[data-mini-cart]');
}

function openMiniCart() {
  const root = getMiniCartRoot();
  if (root) root.classList.add('open'); // your class is "open"
}

async function refreshMiniCart() {
  const wrapper = getMiniCartWrapper();
  if (!wrapper) return;

  try {
    // Section Rendering API: returns JSON { "<sectionId>": "<html>" }
    const res = await fetch(`/?sections=${encodeURIComponent(MINI_CART_SECTION_ID)}`, {
      credentials: 'same-origin'
    });
    if (!res.ok) throw new Error('Section fetch failed');

    let html;
    try {
      const json = await res.json();
      html = json && json[MINI_CART_SECTION_ID];
    } catch {
      // Rare proxies can strip JSON; fallback to text
      html = await res.text();
    }
    if (!html) throw new Error('Empty section HTML');

    wrapper.innerHTML = html;

    // Re-query the freshly injected drawer and open it
    openMiniCart();

    // Optional: let other scripts re-init
    document.dispatchEvent(new CustomEvent('mini-cart:refreshed'));
  } catch (e) {
    console.warn('Mini-cart refresh failed:', e);
  }
}

  // ----- FIND PRODUCT FORM -----
  const productForm = document.querySelector('form[action="/cart/add"], form[id^="product-form"], form.product-form');
  if (!productForm) return;

  // ----- INTERCEPT SUBMIT -----
  productForm.addEventListener('submit', async (e) => {
    e.preventDefault();

    const submitter = e.submitter || productForm.querySelector('[type="submit"]');
    const originalText = submitter?.value || submitter?.textContent;

    const formData = new FormData(productForm);

    if (submitter && submitter.name) {
      formData.append(submitter.name, submitter.value);
    }

    // Disable button
    if (submitter) {
      submitter.disabled = true;
      if ('value' in submitter) submitter.value = 'Adding...';
      else submitter.textContent = 'Adding...';
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData,
        credentials: 'same-origin'
      });

      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData.description || 'Could not add to cart.');
      }

      await refreshMiniCart();
    } catch (err) {
      console.error(err);
      alert(err.message || 'There was a problem adding this item to your cart.');
    } finally {
      if (submitter) {
        submitter.disabled = false;
        if ('value' in submitter) submitter.value = originalText;
        else submitter.textContent = originalText;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockists"] && !Shopify.designMode) return;
  try {
    
/* Stockists */
  const WIDE   = '(min-width: 1600px)';
  const NARROW = '(min-width: 900px)';

  const debounce = (fn, ms=150) => {
    let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  };

  function getLimit(container) {
    const m = parseInt(container.dataset.mobile || '13', 10);
    const n = parseInt(container.dataset.narrow || '39', 10);
    const w = parseInt(container.dataset.wide   || '52', 10);
    if (window.matchMedia(WIDE).matches)   return w;
    if (window.matchMedia(NARROW).matches) return n;
    return m;
  }

  function applyLimit(container, {expanded}) {
    const items = container.querySelectorAll('.stockists__item');
    const btn   = container.querySelector('.stockists__toggle-btn');
    const total = items.length;
    const limit = getLimit(container);

    // If expanded, show all; else hide beyond limit
    items.forEach((li, i) => {
      if (expanded || i < limit) {
        li.classList.remove('is-hidden');
      } else {
        li.classList.add('is-hidden');
      }
    });

    // Button visibility + label
    const shouldShowButton = total > limit;
    btn.hidden = !shouldShowButton && !expanded; // hide if nothing to reveal
    btn.textContent = expanded ? 'View Less' : 'View More';
  }

  function init(container) {
    if (container.dataset.initialized === 'true') return;
    container.dataset.initialized = 'true';

    const state = { expanded: false };
    const btn = container.querySelector('.stockists__toggle-btn');

    // Initial render
    applyLimit(container, state);

    // Toggle handler
    btn.addEventListener('click', (e) => {
        e.preventDefault();
      state.expanded = !state.expanded;
      applyLimit(container, state);
    });

    // Update on resize / breakpoint change
    const update = debounce(() => applyLimit(container, state), 150);
    window.addEventListener('resize', update);

    // Also listen to media query changes (more reliable in some browsers)
    const mqN = window.matchMedia(NARROW);
    const mqW = window.matchMedia(WIDE);
    mqN.addEventListener ? mqN.addEventListener('change', update) : mqN.addListener(update);
    mqW.addEventListener ? mqW.addEventListener('change', update) : mqW.addListener(update);
  }

    document.querySelectorAll('.stockists').forEach(init);

  } catch(e) { console.error(e); }
})();
})();
